export const formatMoney = function (
  num: number,
  decimals: number,
  decimal_sep: string,
  thousands_sep: string
) {
  var n = num,
    c = isNaN(decimals) ? 2 : Math.abs(decimals), //if decimal is zero we must take it, it means user does not want to show any decimal
    d = decimal_sep || ".", //if no decimal separator is passed we use the dot as default decimal separator (we MUST use a decimal separator)
    /*
   according to [https://stackoverflow.com/questions/411352/how-best-to-determine-if-an-argument-is-not-sent-to-the-javascript-function]
   the fastest way to check for not defined parameter is to use typeof value === 'undefined' 
   rather than doing value === undefined.
   */

    t = typeof thousands_sep === "undefined" ? "," : thousands_sep, //if you don't want to use a thousands separator you can pass empty string as thousands_sep value
    sign = n < 0 ? "-" : ""

  const nAsNumber = Math.abs(n).toFixed(c)

  //extracting the absolute value of the integer part of the number and converting to string
  const i = parseInt(nAsNumber) + ""
  let j = i.length
  j = (j = i.length) > 3 ? j % 3 : 0

  return (
    sign +
    (j ? i.substr(0, j) + t : "") +
    i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) +
    (c
      ? d +
        Math.abs(n - parseInt(i, 10))
          .toFixed(c)
          .slice(2)
      : "")
  )
}
